import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"

@Component({
	selector: "app-send-users-email",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		WysiwygComponent,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<label>{{ "users" | langVal }}</label>
			@for (item of checkedItems; track item) {
				<p>{{ item.user_name }} - {{ item.email }}</p>
			}
		</div>
		<div class="row form-group">
			<app-wysiwyg
				[actualObj]="this"
				fieldName="message"
			/>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				text="confirm"
				(clickEv)="send()"
				[isSpin]="isSending"
			/>
		</div>
	`,
})
export class SendUsersEmailComponent extends Modalable {
	message: string = "" //the message to send to the api
	@Input() checkedItems: any[] = [] //list of items to send to the api
	isSending: boolean = false

	async send() {
		//send item ids and message to api
		const sendObj = {
			message: this.message,
			ids: this.checkedItems.map((row) => row.id),
		} //send message and extracted ids from the checkedItems list
		this.isSending = true
		const res: any = await this.apiService.post("send_users_email", sendObj)
		this.isSending = false
		if (res.message == "success") {
			//if success
			this.modalService.openToast("sent_successfully") //toast message of success
			this.onClose.emit() //close this modal
		}
	}
}
